import servicesAiMl from "../assets/services-ai-ml.png";
import servicesCloudNative from "../assets/services-cloud-native.png";
import servicesEnterpriseApps from "../assets/services-enterprise-apps.png";
import servicesEnterpriseArch from "../assets/services-enterprise-arch.png";
import servicesUiUx from "../assets/services-ui-ux.png";
import servicesWebMobile from "../assets/services-web-mobile.png";

export type ServiceSectionData = {
  title: string;
  paragraphs: string[];
  items: string[];
  image: string;
  imageAlt: string;
  variant: "dark" | "light";
};

export const servicesHero = {
  title: "Sundeus Offerings",
  intro:
    "We at 'Sundeus' use Enterprise Architecture to design the holistic and detailed view of the enterprise resulting in better, faster and cheaper business/IT opeartions, better return on existing investment and reduced risk for future investment.",
};

export const serviceSections: ServiceSectionData[] = [
  {
    title: "Enterprise Architecture",
    paragraphs: [
      "Sundeus EA Consulting is an amalgamation of practitioners with decades of enterprise architecture experience and young energetic minds, who are full of passion and energy to do something out of the box and new to solve customer problems. The core of architecture is based on business outcome-driven, customer-centric and future-ready.",
    ],
    items: [
      "IT Strategy and Roadmap",
      "EA Assessment and Application Portfolio Rationalisation (APR)",
      "Future State Architecture (FSA)",
      "Enterprise Architecture Governance",
      "Reference Architecture",
      "Enterprise Solution Architecture",
      "Digital Maturity Assessment",
    ],
    image: servicesEnterpriseArch,
    imageAlt: "Enterprise Architecture illustration",
    variant: "dark",
  },
  {
    title: "UI / UX",
    paragraphs: [
      "What differentiates good UX from great UX? It's expertise.",
      "Our user experience consultants offer a wide range of consulting and training services.",
    ],
    items: [
      "UX / UI Audit",
      "Business Model Validation & Product Concepts",
      "UX Reserach",
      "Usability Testing",
      "User Journey",
      "Empathy Map",
      "Visual Design",
      "Information Architecture (IA)",
      " Wireframing & Prototyping",
    ],
    image: servicesUiUx,
    imageAlt: "UI/UX design illustration",
    variant: "light",
  },
  {
    title: "Artificial Intelligence (AI/ML)",
    paragraphs: [
      "Artificial Intelligence is bringing value to the business through deep insight, decision making & intelligent automation. Sundeus AI Consultants are upto the mark with the industry leading AI research and technology innovations. We have the right expertise supported by our AI Lab to provide required business driven AI features and capabilities. Our key expertise area includes:",
    ],
    items: [
      "Google AI Hub",
      "Azure Cognitive Services",
      "Open Source Framework (Tensorflow, PyTorch)",
      "Open AI",
      "Meta Llama",
      "Amazon Bedrock",
      "IBM Watsonx",
    ],
    image: servicesAiMl,
    imageAlt: "Artificial Intelligence illustration",
    variant: "dark",
  },
  {
    title: "Cloud-Native Platforms",
    paragraphs: [
      "Cloud-native platforms empower organizations to build scalable, resilient, and future-ready digital solutions. Our cloud experts help design and implement modern architectures on AWS, Azure, and GCP, leveraging microservices, automation, and DevOps practices to accelerate innovation, improve reliability, and support business growth .",
    ],
    items: [
      " Cloud Strategy & Migration",
      " AWS, Azure & GCP Solutions",
      " Microservices Architecture Design",
      " DevOps & CI/CD Automation",
      " Infrastructure as Code (IaC)",
      " Cloud Security & Compliance",
    ],
    image: servicesCloudNative,
    imageAlt: "Cloud-Native Platforms illustration",
    variant: "light",
  },
  {
    title: "Web & Mobile App",
    paragraphs: [
      "We build intelligent web and mobile applications that combine modern technology, AI-driven capabilities, and exceptional user experiences. Our solutions are designed to be scalable, secure, and performance-focused, helping businesses streamline operations, enhance customer engagement, and accelerate digital growth.",
    ],
    items: [
      " Custom Web Application Development",
      " Mobile App Development (iOS & Android)",
      " AI-Powered Solutions & Automation",
      " UI/UX Design & User Experience",
      " API Integration & System Connectivity",
      " Scalable & Secure Application Architecture",
      " Performance Optimization & Maintenance",
    ],
    image: servicesWebMobile,
    imageAlt: "Web and Mobile App illustration",
    variant: "dark",
  },
  {
    title: "Enterprise Applications",
    paragraphs: [
      "Empowering businesses with SAP-driven enterprise solutions that streamline operations, improve efficiency, and accelerate digital transformation. We provide end-to-end SAP services to optimize core business processes and drive sustainable growth.",
    ],
    items: [
      " SAP Implementation",
      " SAP Integration",
      " SAP Customization",
      " SAP Migration",
      " Business Process Optimization",
      " SAP Support & Maintenance",
      " Digital Transformation Solutions",
    ],
    image: servicesEnterpriseApps,
    imageAlt: "Enterprise Applications illustration",
    variant: "light",
  },
];
